import { render, staticRenderFns } from "./Study.vue?vue&type=template&id=57011016&scoped=true&"
import script from "./Study.vue?vue&type=script&lang=js&"
export * from "./Study.vue?vue&type=script&lang=js&"
import style0 from "./Study.vue?vue&type=style&index=0&id=57011016&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57011016",
  null
  
)

export default component.exports